import { render, staticRenderFns } from "./TimeControl.vue?vue&type=template&id=472cd0c2&scoped=true&"
import script from "./TimeControl.vue?vue&type=script&lang=js&"
export * from "./TimeControl.vue?vue&type=script&lang=js&"
import style0 from "./TimeControl.vue?vue&type=style&index=0&id=472cd0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cd0c2",
  null
  
)

export default component.exports